"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.hastPropertiesToJs = exports.markupAttributeToHastProperty = exports.hastPropertyToMarkup = exports.xmlSpace = exports.htmlSpace = void 0;
var info = require('property-information');
exports.htmlSpace = info.html;
exports.xmlSpace = info.xml;
var findPropertyInfo = function (infoSpace, propertyOrAttr) {
    return info.find(infoSpace, propertyOrAttr) || null;
};
var hastPropertyToJs = function (infoSpace, property, value) {
    var _a, _b, _c, _d;
    if (property.startsWith('data-') && infoSpace === exports.htmlSpace) {
        return _a = {}, _a[property] = value, _a;
    }
    var info = findPropertyInfo(infoSpace, property);
    if (!info)
        return {};
    if (info.spaceSeparated || info.commaOrSpaceSeparated) {
        return _b = {}, _b[property] = value.join(' '), _b;
    }
    else if (info.commaSeparated) {
        return _c = {}, _c[property] = value.join(', '), _c;
    }
    return _d = {}, _d[property] = value, _d;
};
exports.hastPropertyToMarkup = function (infoSpace, property, value) {
    if (property.startsWith('data-') && infoSpace === exports.htmlSpace) {
        return [property, value];
    }
    var info = findPropertyInfo(infoSpace, property);
    if (!info)
        return null;
    var attribute = info.attribute;
    if (info.boolean || info.overloadedBoolean) {
        return value ? attribute : null;
    }
    if (info.spaceSeparated || info.commaOrSpaceSeparated) {
        return [attribute, typeof value === 'string' ? value : value.join(' ')];
    }
    if (info.commaSeparated) {
        return [attribute, typeof value === 'string' ? value : value.join(', ')];
    }
    return [attribute, "" + value];
};
exports.markupAttributeToHastProperty = function (infoSpace, attribute, value) {
    var _a, _b, _c, _d, _e, _f, _g;
    if (attribute.startsWith('data-') && infoSpace === exports.htmlSpace) {
        return _a = {}, _a[attribute] = value, _a;
    }
    var info = findPropertyInfo(infoSpace, attribute);
    if (!info)
        return {};
    var property = info.property;
    if (info.boolean || info.overloadedBoolean) {
        return _b = {}, _b[property] = true, _b;
    }
    if (info.booleanish) {
        return _c = {}, _c[property] = value.toLowerCase().includes('false') ? false : true, _c;
    }
    if (info.spaceSeparated) {
        return _d = {}, _d[property] = value.split(/[\s]+/), _d;
    }
    if (info.commaSeparated) {
        return _e = {}, _e[property] = value.split(/[,]/).map(function (str) { return str.trim(); }), _e;
    }
    if (info.commaOrSpaceSeparated) {
        return _f = {}, _f[property] = value.split(/[\s,]+/), _f;
    }
    return _g = {}, _g[property] = value, _g;
};
exports.hastPropertiesToJs = function (infoSpace, properties) {
    if (!properties)
        return null;
    return Object.keys(properties).reduce(function (agg, property) { return (__assign(__assign({}, agg), hastPropertyToJs(infoSpace, property, properties[property]))); }, {});
};
